/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';
import { UserContainer } from './user.style';
import { Table, IconButton as IconWithButton, Loader } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import UserService from '../../../services/bioplus-services/user';
import { AddPlusIcon, EyeIcon } from '../../../Components/icons';
import { useCompany } from '../../../hooks/CompanyContext';
import { CorporateAdminViewModal, InviteUserModal } from './modals';
import { IntlMessages } from '../../../helper/langHelper';

const CorporateAdminUsers = () => {
  const [viewUser, setViewUser] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [inviteUser, setInviteUser] = useState();

  const userContext = useUserContext();
  const companyContext = useCompany();
  const parentId = userContext?.company?.companyId?.id;
  const companyFilter = companyContext?.company?._id;

  const usersQuery = useQuery(['corporateAdminUser', parentId, companyFilter, page, pageSize], () =>
    UserService.listByParent(parentId, { companyId: companyFilter }, page, pageSize)
  );
  const userTableData = usersQuery?.data?.items ?? [];

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userName',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.company" />,
        accessor: 'companyName',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'email',
        width: '25%',
      },
      {
        Header: <IntlMessages id="table.col.role" />,
        accessor: 'role',
      },
      {
        Header: <IntlMessages id="table.col.mobile.no" />,
        accessor: 'phone',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
      },
    ],
    []
  );

  const handleClosed = () => {
    setViewUser(undefined);
  };

  const handleClosedInviteUser = () => {
    setInviteUser(false);
  };

  const actionList = [
    (data) => (
      <IconButton onClick={() => setViewUser(data)}>
        <EyeIcon />
      </IconButton>
    ),
  ];

  if (usersQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <UserContainer>
        <HeaderTitle>
          <IntlMessages id="user.module.user" />
        </HeaderTitle>
        {localStorage.getItem('role') !== 'Admin' && (
          <IconWithButton
            text={<IntlMessages id="button.text.add.user" defaultMessage="Add user" />}
            onClick={() => setInviteUser(true)}
            icon={<AddPlusIcon />}
          />
        )}
      </UserContainer>
      <TableWrapper>
        <Table data={userTableData} columns={userColumns} hasFooter={false} actions={actionList} />
      </TableWrapper>
      {viewUser && viewUser !== undefined && (
        <CorporateAdminViewModal onClose={handleClosed} data={viewUser} />
      )}
      {inviteUser && <InviteUserModal onClose={handleClosedInviteUser} companyId={parentId} />}
    </StyledContainer>
  );
};

export default CorporateAdminUsers;
